<template>
  <div class="w-full">
    <div class="searchFilterContent border border-black">
      <div class="flex flex-col justify-center items-center">
        <div class="flex w-full px-4">
          <div class="searchFilterInputContainer w-full mr-4">
            <template>
              <div class="w-full pt-4 pb-2 text-zt-dark-300">
                <zt-autocomplete
                  data-vs-autocomplete="user-list"
                  gtmClass="zt-gtm-documents-inbox-search"
                  :label="$t('message.uploadImageComponent.body.leftContainer.filter.searchLabel')"
                  prependIcon="search"
                  apiSearch
                  clearable
                  outlined
                  returnObject
                  :searchCharacter="3"
                  :items="autocompleteItemList"
                  noResultsText="No hay tareas que coincidan con tu búsqueda"
                  @search="autocompleteSearchUserList"
                  @input="autoCompleteOptionSelected"
                  v-model="userId"
                ></zt-autocomplete>
                <div class="zt-dark-300 text-zt-xs mt-2 custom-gray">
                  {{
                    $t(
                      "message.uploadImageComponent.body.leftContainer.filter.inputBaseMessage"
                    )
                  }}
                </div>
              </div>
            </template>
          </div>
          <zt-button
            data-vs-button="filter"
            @click="filtersContainer = !filtersContainer"
            class="button-filter mt-4 text-base"
            :class="{
              'button-filter-grey': filtersContainer === true,
            }"
            icon="filter-amount"
            gtmClass="zt-gtm-documents-inbox-filters"
            >{{ $t("message.uploadImageComponent.body.leftContainer.filter.filterButton") }}</zt-button
          >
        </div>
        <transition name="fade">
          <div class="wrapper-filters w-full flex justify-center text-base">
            <div
              v-show="filtersContainer"
              class="overflow-hidden w-11/12"
              :class="{
                expanded: filtersContainer === true,
              }"
            >
              <template>
                <div class="inline-block mt-3 mb-1 mx-1">
                  <zt-dropdown
                    data-vs-dropdown="date-rage"
                    ref="ztDropdownDate"
                    class="mr-2 mb-2"
                    :label='$t("message.uploadImageComponent.body.leftContainer.filter.date")'
                    clearable
                    v-slot="{ itemSelected }"
                    v-model="dateRage"
                    size-adjustable
                    gtmClass="zt-gtm-documents-inbox-date-filter"
                  >
                    <zt-dropdown-item
                      v-for="(item, index) of state.filters.options.date_range_filter"
                      :key="index"
                      :item="item"
                      :item-selected="itemSelected"
                      :data-vs-option-value="`option-${index}`"
                    />
                  </zt-dropdown>
                  <zt-dropdown
                    data-vs-dropdown="doctype"
                    clearable
                    ref="ztDropdownDocumentType"
                    class="mr-2 mb-2"
                    :label='$t("message.uploadImageComponent.body.leftContainer.filter.documentType")'
                    :disabled="!state.filters.options.document_types_filter.length"
                    v-slot="{ itemSelected }"
                    v-model="documentTypeId"
                    size-adjustable
                    gtmClass="zt-gtm-documents-inbox-doc-type-filter"
                  >
                    <zt-dropdown-item
                      v-for="(item, index) of state.filters.options
                        .document_types_filter"
                      :key="index"
                      :item="item"
                      :item-selected="itemSelected"
                      :data-vs-option-value="`doc-${index}`"
                    />
                  </zt-dropdown>
                  <zt-dropdown
                    data-vs-dropdown="sector"
                    clearable
                    ref="ztDropdownSector"
                    class="mr-2 mb-2"
                    :label='$t("message.uploadImageComponent.body.leftContainer.filter.sector")'
                    :disabled="!state.filters.options.sectors_filter.length"
                    v-slot="{ itemSelected }"
                    v-model="sector"
                    size-adjustable
                    gtmClass="zt-gtm-documents-inbox-sector-filter"
                  >
                    <zt-dropdown-item
                      v-for="(item, index) of state.filters.options.sectors_filter"
                      :key="index"
                      :item="item"
                      :item-selected="itemSelected"
                      :data-vs-option-value="`sector-${index}`"
                    />
                  </zt-dropdown>
                  <zt-dropdown
                    data-vs-dropdowm="location"
                    clearable
                    class="mb-2"
                    ref="ztDropdownLocation"
                    :label='$t("message.uploadImageComponent.body.leftContainer.filter.locacion")'
                    :disabled="!state.filters.options.locations_filter.length"
                    v-slot="{ itemSelected }"
                    v-model="location"
                    size-adjustable
                    gtmClass="zt-gtm-documents-inbox-location-filter"
                  >
                    <zt-dropdown-item
                      v-for="(item, index) of state.filters.options.locations_filter"
                      :key="index"
                      :item="item"
                      :item-selected="itemSelected"
                      :data-vs-option-value="`location-${index}`"
                    />
                  </zt-dropdown>
                </div>
              </template>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import UserManagement from "../../apiClient/UserManagement";
import User from "../../apiClient/Employee";
import moment from "moment";

export default {
  inject: ['state', 'mutations'],
  props: {
    selectedUser: {
      type: Object,
      default: {}
    },
    isCheckAll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      UserManagementApi: UserManagement,
      UserApi: User,
      autocompleteItemList: [],
      dateRage: {},
      documentTypeId: {},
      location: {},
      sector: {},
      userId: {},
      filtersContainer: false,
    };
  },
  created() {
    this.UserManagementApi = new UserManagement();
    this.UserApi = new User();
    this.generateRangeDateOptions();
    this.getListDocumentsWaitingFilters(null);
  },
  watch: {
    dateRage: function(val) {
      this.mutations.setDateRage(val)
      this.changeFiltersValue()
    },
    documentTypeId: function(val) {
      this.mutations.setDocumentTypeId(val)
      this.changeFiltersValue()
    },
    location: function(val) {
      this.mutations.setLocation(val)
      this.changeFiltersValue()
    },
    sector: function(val) {
      this.mutations.setSector(val)
      this.changeFiltersValue()
    },
  },
  methods: {
    autoCompleteOptionSelected(e) {
      if (!e.target && !e.srcElement) {
        this.mutations.setUserId(this.userId)
        if (Object.keys(this.selectedUser).length) {
          this.$emit("clean-selected-user")
        }

        const params = !_.isEmpty(this.state.filters.params.userId)
          ? { userId: `["${this.state.filters.params.userId.value}"]` }
          : null;
        this.getListDocumentsWaitingFilters(params, true);
      }
    },
    autocompleteSearchUserList(filter) {
      this.UserManagementApi.searchActiveUsers({ filter })
        .then((response) => {
          if (response.status === 200 && response.data.data) {
            this.autocompleteItemList = response.data.data.map((element) => {
              return {
                text: element.nombre,
                value: element.id,
              };
            });
          } else {
            this.autocompleteItemList = [];
          }
        })
        .catch(() => {
          this.autocompleteItemList = [];
        });
    },
    generateRangeDateOptions() {
      const toDay = moment().format("YYYY-MM-DD");
      const tomorrowDay = moment().add(1, "days").format("YYYY-MM-DD");
      this.mutations.setDateRageFilter([
        {
          value: [toDay, tomorrowDay],
          text: "Hoy",
        },
        {
          value: [
            moment().subtract(1, "days").format("YYYY-MM-DD"),
            moment().subtract(1, "days").format("YYYY-MM-DD"),
          ],
          text: "Ayer",
        },
        {
          value: [
            moment().subtract(7, "days").format("YYYY-MM-DD"),
            tomorrowDay,
          ],
          text: "Ultima Semana",
        },
        {
          value: [
            moment().subtract(30, "days").format("YYYY-MM-DD"),
            tomorrowDay,
          ],
          text: "Ultimo Mes",
        },
      ]);
    },
    changeFiltersValue() {
      this.$emit("clean-massivearray");
      const params = this.mutations.formatParams();
      this.getListDocumentsWaitingFilters(params, true);
    },
    async getListDocumentsWaitingFilters(objFilters, update) {
      if (this.isCheckAll) {
        this.$emit("check-all")
      }

      await this.UserApi.getDocumentWaitingFilters(objFilters)
        .then(async (response) => {
          try {
            const filters = response.data.data[0];
            if (
              !filters.document_types_filter[
                this.state.filters.params.documentTypeId.value
              ]
            ) {
              await this.mutations.setDocumentTypeId({value: {}});
            }
            if (
              !filters.locations_filter.indexOf(
                this.state.filters.params.location.value
              ) === -1
            ) {
              await this.mutations.setLocation({value: {}});
            }
            if (
              !filters.sectors_filter.indexOf(
                this.state.filters.params.sector.value
              ) === -1
            ) {
              await this.mutations.setSector({value: {}});
            }

            const formatted = Object.keys(filters)
              .map((key) => {
                return {
                  [key]: Array.isArray(filters[key])
                    ? filters[key].map((text) => ({ text, value: text }))
                    : Object.entries(filters[key]).map(([value, text]) => ({
                        text,
                        value,
                      })),
                };
              })
              .reduce((a, b) => {
                for (let key in b) {
                  if (b.hasOwnProperty(key)) {
                    a[key] = b[key];
                  }
                }
                return a;
              }, {});

            _.each(formatted, async (group, key) => {
              switch (key) {
                case "document_types_filter":
                  const docType = _.find(
                    group,
                    this.state.filters.params.documentTypeId
                  );
                  if (!docType) {
                    this.$refs.ztDropdownDocumentType.reset();
                    await this.mutations.setDocumentTypeId({});
                  }
                  break;
                case "sectors_filter":
                  const sector = _.find(
                    group,
                    this.state.filters.params.sector
                  );
                  if (!sector) {
                    this.$refs.ztDropdownSector.reset();
                    await this.mutations.setSector({});
                  }
                  break;
                case "locations_filter":
                  const location = _.find(
                    group,
                    this.state.filters.params.location
                  );
                  if (!location) {
                    this.$refs.ztDropdownLocation.reset();
                    await this.mutations.setLocation({});
                  }
                  break;
                default:
              }
            });

            await this.mutations.setOptions(formatted)
          } catch (e) {
            this.clearFilters();
          }
          if (update) this.$emit("update-documents")
        })
        .catch(() => {
          this.clearFilters();
          this.$emit("update-documents")
        });
    },
    clearFilters() {
      this.$refs.ztDropdownDocumentType.reset();
      this.$refs.ztDropdownSector.reset();
      this.$refs.ztDropdownLocation.reset();
      this.mutations.cleanFilters()
    },
  },
};
</script>

<style scoped lang="scss">
.searchFilterContent {
  background: #FFF;
}

.searchFilterInputContainer {
  position: relative;
}

.searchFilterInputContainer input {
  font-size: 0.7vw;
  text-indent: 30px;
}

.searchFilterInputContainer .icon-Search {
  position: absolute;
  top: 8px;
  left: 1px;
  font-size: 20px;
}

button.button-filter {
  background-color: #ffffff;
  border: 1px solid #d6d6d6;
  color: #686868 !important;
  box-shadow: none;
  height: 2.94rem;
}

button.button-filter:hover {
  box-shadow: none;
}

button.button-filter-grey {
  background-color: #d6d6d6 !important;
}

::v-deep button.button-filter {
  i.zt-icon-filter-amount {
    transition: transform 0.4s ease-in-out;
    transform: rotate(0deg);
  }
}

::v-deep button.button-filter-grey {
  i.zt-icon-filter-amount {
    transition: transform 0.4s ease-in-out;
    transform: rotate(180deg);
  }
}
</style>